import Image from 'next/image'

import type { SubscriptionBoxHistories } from '@lib/types/subscription-box'

import OrderDetails from './OrderDetails'

type MonthlyBoxOrderCardProps = {
	order: SubscriptionBoxHistories[number]
	openOrderModal: (orderId: string) => void
}

export default function MonthlyBoxOrderCard({ order, openOrderModal }: MonthlyBoxOrderCardProps) {
	return (
		<button
			type="button"
			className="order-card"
			onClick={() => openOrderModal(order?.fulfillmentOrderId)}
		>
			{/* Images row monthly box order */}
			{Array.isArray(order?.productSelections) && (
				<div className="flex items-center justify-center px-6 pt-8 pb-6 border-b gap-x-3 border-gray-200">
					{order.productSelections.map(({ imageUrl }, i) =>
						i <= 4 ? (
							// eslint-disable-next-line react/no-array-index-key
							<div key={`product-${i}`}>
								{imageUrl && (
									<Image
										src={imageUrl}
										alt="Subscription box product"
										width={48}
										height={48}
										className="object-contain"
									/>
								)}
							</div>
						) : null
					)}

					{/* Overflow count indicator */}
					{order.productSelections.length > 5 && (
						<div className="mr-4 font-medium text-gray-500">
							+{order.productSelections.length - 5}
						</div>
					)}
				</div>
			)}

			{/* TODO: pass info here */}
			<OrderDetails order={order} />
		</button>
	)
}
